<template>

	<widget
			  :max-height="maxHeight"
			  title="Your Review Items">

		<div class="text-center">
			<h2>Hey there - Look up!</h2>

			<p>We have all your review items in a dedicated panel at the top now!</p>

			<i class="fa fa-arrow-circle-up fa-5x text-success"></i>
		</div>

	</widget>

</template>
<script type="text/javascript">
import ModalDialog from "@/components/ModalDialog"
import Widget from "@/components/Widget"
import TableList from "@/components/TableList"
import ButtonGroup from "@/components/ButtonGroup"

export default {
	name: "ReviewItemsWidget",
	components: {
		ButtonGroup,
		ModalDialog,
		Widget,
		TableList
	},
	props: ["maxHeight"],
	data() {
		return {
			numTimeLogsToReview: 0,
			numExpensesToReview: 0,
			numCompanyFormsToReview: 0,
			//numLocatesToReview: 0,	Now a computed variable
			numServicesArchivable: 0,
			numProjectsArchivable: 0,
			numServicesIncomplete: 0,
			numVacationRequests: 0,
			numUnseenInvoices: 0,
			unseenDays: 4,
			companyForms: [],
			ticketIDs: [],
			ticketsToReview: [],
			mutatedLocates: [],
			archivableServices: [],
			archivableProjects: [],
			outstandingChangeOrders: [],
			incompleteServices: [],
			unseenInvoices: [],
			vacationRequests: [],
			reviewableLogsFetched: false,
			//modalDialogVisible: false,
			companyFormsModalVisible: false,
			locatesModalVisible: false,
			serviceListModalVisible: false,
			projectsListModalVisible: false,
			unseenInvoicesModal: {
				visible:  false,
				spinner: false
			},
			companyFormsLoading: false,
			markLocateModal: {			// Change mark status of locate
				isVisible: false,
				action: "",
				locate_id: ""
			},
			incompleteServicesModal: {
				visible: false,
				service: null
			},
			vacationRequestsModal: {
				visible: false,
				spinner: false
			},
			outstandingChangeOrdersModal: {
				visible: false,
				spinner: false
			}
		}
	},
	computed: {

		mutatedCompanyForms() {
			return this.companyForms.map(ack => {

				let form = ack.CompanyForm   // shorthand for clarity
				
				
				ack.formDescription = ""

				if ('FormChildTemplate' in form && form.FormChildTemplate) {
					if ('description' in form.FormChildTemplate && form.FormChildTemplate.description)
						ack.formDescription = form.FormChildTemplate.description
				}



				ack.jobNum = { text:"", link:"" }

				if ('Job' in form && form.Job) {
					if ('job_num' in form.Job && form.Job.job_num) {
						ack.jobNum.text = "Project #" + form.Job.job_num
						ack.jobNum.link = "/project/" + form.Job.slug + "/dashboard"
					}
				}

				else if ('Service' in form && form.Service) {
					if ('job_num' in form.Service && form.Service.job_num) {
						ack.jobNum.text = "Service #" + form.Service.job_num
						ack.jobNum.link = "/service/" + form.Service.slug+"/dashboard"
					}
				}


				ack.equipmentDescription = ""

				if ('Equipment' in form && form.Equipment) {
					if ('description' in form.Equipment && form.Equipment.description)
						ack.equipmentDescription = form.Equipment.description
				}


				return ack
			})
		},

		numLocatesToReview() {
			return this.ticketsToReview.filter(ticket => {
				return (ticket.action == "") ||
					(ticket.action == "Hold" && ticket.action_last_updated < this.moment().subtract(2,"weeks").format("YYYY-MM-DD HH:mm:ss"))
			}).length
		},

		numOutstandingChangeOrders() {
			return this.outstandingChangeOrders.length
		},
		mutatedIncompleteServices() {
			return this.incompleteServices.map(service => {
				service.hasInternalNotes = service.internal_notes && service.internal_notes != ""
				service.jobNum = {
					text: service.job_num,
					link: "/service/"+service.slug+"/dashboard"
				}

				return service
			})
		},

		mutatedArchivableProjects() {
			this.numProjectsArchivable

			return this.archivableProjects.map(job => {
				job.jobNum = {
					text: job.job_num,
					link: "/service/"+job.slug+"/dashboard"
				}

				return job
			})
		},
		mutatedArchivableServices() {
			if (!this.archivableServices)
				return []

			return this.archivableServices.map(service => {
				service.jobNum = {
					text: service.job_num,
					link: "/service/"+service.slug+"/dashboard"
				}

				return service
			})
		},
		mutatedInvoices() {
			let vm = this
			return this.unseenInvoices.map(inv => {

				let text = "", link = ""

				if ("Service" in inv && inv.Service) {
					text = inv.Service.job_num
					link = "/service/"+inv.Service.slug+"/invoice"
				}	
				else if ("Job" in inv && inv.Job) {
					text = inv.Job.job_num + "-" + inv.invoice_num
					link = "/project/"+inv.Job.slug+"/billing/"+inv.slug
				}
				else {
					text = inv.standalone_num
					link = "/invoice/"+inv.slug+"/details"
				}

				if (inv.manual_invoice_number)
					text = inv.manual_invoice_number

				inv.invoiceNum = {
					text,
					link
				}

				inv.customerName = ""
				if ("Customer" in inv && inv.Customer)
					inv.customerName = inv.Customer.name
				else if ("Job" in inv && inv.Job && "Customer" in inv.Job && inv.Job.Customer)
					inv.customerName = inv.Job.Customer.name
				else if ("Job" in inv && inv.Job && "customer_name_cache" in inv.Job)
					inv.customerName = inv.Job.customer_name_cache
				else if ("Service" in inv && inv.Service && "customer_name_cache" in inv.Service)
					inv.customerName = inv.Service.customer_name_cache

				inv.firstIssued = vm.formatDate(inv.date_first_issued)

				return inv
			})
		},
		mutatedVacationRequests() {
			let vm = this

			return this.vacationRequests.map(event => {
				event.userFullName = event.User.first_name + " " + event.User.last_name

				event.startTimeFormatted = vm.formatDateTimeToLocal(event.start_time)
				event.endTimeFormatted = vm.formatDateTimeToLocal(event.end_time)

				return event
			})
		},
		mutatedChangeOrders() {
			let vm = this

			return this.outstandingChangeOrders.map(co => {
				co.coNumber = {}
				co.projectNum = {}

				if ("Job" in co && co.Job) {
					co.projectNum = {
						text: co.Job.job_num,
						link: "/project/" + co.Job.slug + "/dashboard"
					}

					co.coNumber = {
						text: "CO-" + co.Job.job_num + "-" + co.quote_num,
						link: "/project/" + co.Job.slug + "/change-orders/" + co.slug
					}
				}

				return co
			})
		}
	},
	methods: {
		openIncompleteServiceNotes(item) {
			this.incompleteServicesModal.service = item
		},
		doCompanyForm(ackRecord) {
			let formLink = "/form/external/"+ackRecord.CompanyForm.slug+"/"+ackRecord.slug
			window.open(formLink, '_blank');
		},
		mutateLocates() {
			let vm = this

			this.mutatedLocates = this.ticketsToReview.map(ticket => {

				// Use the first locate in the ticket as a reference
				// for repeating member values
				let locate = ticket.Locate[0]

				let copyKeys = ['status', 'expiry_date', 'refresh_date']
				copyKeys.forEach(key => {
					ticket[key] = locate[key]
				})

				ticket.Locate.forEach(locate => {

					if (locate.expiry_date < ticket.expiry_date)
						ticket.expiry_date = locate.expiry_date

					if (locate.refresh_date < ticket.refresh_date)
						ticket.refresh_date = locate.refresh_date
				})

				if (ticket.expiry_date < this.moment().format("YYYY-MM-DD"))
					ticket.fullExpiryDate = "<span class='text-danger'>" + ticket.expiry_date + "</span>"
				else
					ticket.fullExpiryDate = ticket.expiry_date

				if ('Job' in ticket && ticket.Job)
					ticket.jobName = ticket.Job.job_name
				else if ('Service' in ticket && ticket.Service)
					ticket.jobName = ticket.Service.job_name
				else
					ticket.jobName = ""

				let actionIcon = ""
				let actionColor = ""

				if (ticket.action == 'Refresh') {
					actionIcon = "fa fa-sync"
					actionColor = "text-success"
				} else if (ticket.action == 'Hold') {
					actionIcon = "fa fa-pause-circle"
					actionColor = "text-warning"
				} else if (ticket.action == 'Close') {
					actionIcon = "fa fa-times-circle"
					actionColor = "text-danger"
				}

				ticket.fullAction = "<i class='" + actionIcon + " " + actionColor + "'>"
				return ticket

			})
			.sort((a,b) => {
				return (a.expiry_date < b.expiry_date) ? -1 : 1
			})
		},
		changeLocateAction(action) {
			this.markLocateModal.action = action
		},
		openMarkLocateModal(ticket) {
			this.markLocateModal.ticket_id = ticket.id

			if ('action' in ticket)
				this.markLocateModal.action = ticket.action

			this.markLocateModal.isVisible = true
		},
		otherButtonClick(record,action) {
			this[action](record);
		},
		saveLocateMark() {
			let vm = this

			let payload = {
				id: vm.markLocateModal.ticket_id,
				action: vm.markLocateModal.action
			}

			this.postData("LocateTicket/save", payload,true).then(response => {
				if (response.success){
					// Success? Find locate in list and update action directly
					let ticket = vm.ticketsToReview.find(ticket => ticket.id == vm.markLocateModal.ticket_id)
					ticket.action = vm.markLocateModal.action
					ticket.action_last_updated = vm.moment().utc().format("YYYY-MM-DD HH:mm:ss")
					vm.mutateLocates()

					// Reset modal
					vm.markLocateModal.isVisible = false
					vm.markLocateModal.ticket_id = ""
					vm.markLocateModal.action = ""
				}
			})
		},
		viewUnseenInvoices() {
			this.unseenInvoicesModal.visible = true
			this.fetchUnopenedInvoices(false)
		},
		viewVacationRequests() {
			let vm = this

			this.vacationRequestsModal.visible = true
		},
		viewOutstandingChangeOrders() {
			this.outstandingChangeOrdersModal.visible = true
		},
		approveVacation(event) {
			let vm = this

			let payload = {
				approved: 1,
				user_id: event.user_id,
				id: event.id
			}

			this.postData("ScheduleEvent/vacation-approval",payload,true).then(response => {
				if (response.success)
					vm.fetchVacationRequests()
			})
		},
		rejectVacation(event) {
			let vm = this

			let payload = {
				approved: 0,
				user_id: event.user_id,
				id: event.id
			}

			this.postData("ScheduleEvent/vacation-approval",payload,true).then(response => {
				if (response.success)
					vm.fetchVacationRequests()
			})
		},
		archiveAllProjects() {
			let vm = this

			let payload = {
				records: JSON.stringify(vm.archivableProjects.map(project => {
					return {
						id: project.id,
						archived: 1
					}
				}))
			}

			this.postData("Job/save-batch",payload).then(response => {
				if (response.success) {
					vm.alertSuccess(response.data.records_saved+" projects archived!")
					vm.fetchArchivableProjects()
				}
			})
		},
		archiveAllServices() {
			let vm = this

			let payload = {
				records: JSON.stringify(vm.archivableServices.map(service => {
					return {
						id: service.id,
						archived: 1
					}
				}))
			}

			this.postData("Service/archive-batch",payload).then(response => {
				if (response.success) {
					vm.alertSuccess(response.data.records_saved+" services archived!")
					vm.fetchArchiveableServices()
				}
			})
		},
		archiveProject(project,index) {
			let vm = this

			this.postData("Job/save",{id:project.id,archived:1},true).then(response => {
				if (response.success) {
					let index = vm.archivableProjects.findIndex(theProject => theProject.id == project.id)

					if (index){
						vm.archivableProjects.splice(index,1)
						vm.numProjectsArchivable--
					}
				}
			})
		},
		archiveService(service,index) {
			let vm = this

			this.postData("Service/save",{id:service.id,archived:1},true).then(response => {
				if (response.success) {
					let index = vm.archivableServices.findIndex(theService => theService.id == service.id)

					if (index >= 0){
						vm.archivableServices.splice(index,1)
						vm.numServicesArchivable--
					}
				}
			})
		},
		changeChangeOrderStatusToApproved(changeOrder) {
			let vm = this

			let payload = {
				id: changeOrder.id,
				quote_status: "Complete, Approved"
			}

			this.postData("JobChangeOrder/save",payload).then(response => {
				vm.fetchOutstandingChangeOrders(true)
			})
		},
		viewIncompleteServices() {
			this.incompleteServicesModal.service = null
			this.incompleteServicesModal.visible = true
		},
		viewProjects() {
			this.projectsListModalVisible = true
		},
		viewServices() {
			this.serviceListModalVisible = true
		},
		viewCompanyForms() {
			if (!this.companyForms.length)
				this.fetchCompanyForms(true)

			this.companyFormsModalVisible = true
		},
		viewLocates() {
			this.locatesModalVisible = true
		},
		fetchLocateTickets() {
			let vm = this
			vm.spinner(true)

			let include = [
				{
					model: "Locate",
					fields: ["expiry_date", "refresh_date"]
				},
				{
					model: "Job",
					fields: ["job_name"]
				},
				{
					model: "Service",
					fields: ["job_name"]
				}
			]

			let expiryDate = this.moment().add(5,"days").format("YYYY-MM-DD")

			let paramsExpired = {
				filters: [
					["archived", 0],
					["action", 	""],
					["Locate",  true],
					["Locate.expiry_date",   true],
					["Locate.expiry_date <", expiryDate]
				],
				include: include
			}

			let paramsHold = {
				filters: [
					["archived", 0],
					["Locate",   true],
					["action", "Hold"],
					["action_last_updated", true],
					["action_last_updated <", this.moment().subtract(7,"days").format("YYYY-MM-DD HH:mm:ss")]
				],
				include: include
			}

			let promises = [
				this.getJSON("LocateTicket/mine", paramsExpired),
				this.getJSON("LocateTicket/mine", paramsHold)
			]

			Promise.all(promises).then(responses => {

				vm.spinner(false)
				//vm.ticketsToReview = responses[0].data.concat(responses[1].data)
				let fetchedTickets = responses[0] && "data" in responses[0] && responses[0].data ? responses[0].data.concat(responses[1].data) : []

				let tickets = []
				let ticketIDs = []

				fetchedTickets.forEach(ticket => {
					ticket.Locate = ticket.Locate.filter(locate => {
						return locate.expiry_date && locate.expiry_date < expiryDate
					})

					// Unique and contains locates
					if (!ticketIDs.includes(ticket.id) && ticket.Locate.length > 0) {
						ticketIDs.push(ticket.id)
						tickets.push(ticket)
					}
				})

				vm.ticketsToReview = tickets
				vm.mutateLocates()
			})

		},
		fetchUnopenedInvoices(count) {
			let vm = this

			let sinceDays = this.unseenDays

			let baseFilters = [
				["date_first_issued <=",this.moment().subtract(sinceDays,"days").format("YYYY-MM-DD")],
				["seen_log_json",""],
				["is_paid",0],
				["last_emailed >","0000-00-00"]
			]

			let fields = ["Customer","Service","Job","id","slug","standalone_num","manual_invoice_number","invoice_num","date_first_issued"]

			let include = []

			if (!count) {
				include = [
					{
						model: "Contact",
						fields: ["name"]
					},
					{
						model: "Job",
						fields: ["slug","job_num","job_name","Customer"],
						include: ["Contact"]
					},
					{
						model: "Service",
						fields: ["slug","job_num","job_name"]
					}
				]

				vm.unseenInvoicesModal.spinner = true
			}

			let promises = [
				vm.getJSON("ServiceInvoice/get",{
					filters: [
						["finalized",1],
						["is_quote",0],
						...baseFilters
					],
					include,
					count,
					fields
				}),
				vm.getJSON("JobInvoice/get",{
					filters: [
						["is_finalized",1],
						["is_active_version",1],
						...baseFilters
					],
					include,
					count,
					fields
				})
			]

			return new Promise((resolve,reject) => {
				Promise.all(promises).then(responses => {

					
					if (count) {
						vm.numUnseenInvoices = 0

						responses.forEach(response => {
							if (response.success)
								vm.numUnseenInvoices += response.count
						})
					}
					else {
						vm.unseenInvoices = [
							...responses[0].data,
							...responses[1].data
						]
					}

					vm.unseenInvoicesModal.spinner = false

					resolve(responses)

				})
			})
		},
		fetchIncompleteServices() {
			let vm = this

			const params = {
				fields: ['id', 'slug', 'status', 'job_num', 'job_name', 'internal_notes'],
				filters: [
					['archived', 0],
					['status', 'Incomplete', 'and', 'like']
				]
			}

			this.getJSON('Service/get', params).then(response => {
				if (response.success) {
					vm.incompleteServices = response.data
					vm.numServicesIncomplete = response.data.length
				}
			})
		},
		fetchArchiveableServices() {
			let vm = this

			let params = {
				filters: [
					["archived",0],
					["status", "Invoiced"],
					["TimeLog.time_out <",this.moment().subtract(30,"days").format("YYYY-MM-DD")],
					["archived",0,'or'],
					["status", "Canceled"],
				],
				include: [{
					model:"TimeLog",
					fields:["id","time_out"],
					orders: [
						["time_out","DESC"]
					],
					limit: 1
				}],
				fields: ["id","slug","job_name","job_num"]
			}

			this.getJSON("Service/archivable-services").then(response => {
				if (response.success) {
					vm.archivableServices = response.data
					vm.numServicesArchivable = response.data.length
				}
			})
		},
		fetchCompanyForms(fetchAll=false) {
			let vm = this

			// Make sure the widget modal shows that its loading
			this.companyFormsLoading = true

			let params = {
				filters: [
					['user_id', this.$store.userDetails.id],
					['completed_at', null],
					['CompanyForm.deleted',0]
				]
			}

			if (!fetchAll) {
				params.fields = []
				params.include = [{model: "CompanyForm",fields:["deleted"]}]
			} else {
				params.fields = ['form_id']
				params.include = [
					"UserToken",
					{
						model: 'CompanyForm',
						fields: ['expiry', 'child_template_id', 'job_id', 'service_id', 'equipment_id','deleted'],
						include: [
							{ model: 'FormChildTemplate', fields: ['description'] },
							{ model: 'Job',               fields: ['job_num'] },
							{ model: 'Service',           fields: ['job_num'] },
							{ model: 'Equipment',         fields: ['description'] },
						]
					}
				]
			}

			this.getJSON('CompanyFormAcknowledgement/get', params).then(response => {
				if (response.success) {
					vm.numCompanyFormsToReview = response.data.length

					if (fetchAll)
						vm.companyForms = response.data
				}

				vm.companyFormsLoading = false
			})
		},
		fetchVacationRequests() {
			let vm = this

			let params = {
				filters: [
					["is_vacation",1],
					["approved_by",0],
					["rejected_by",0],
					["start_time >",this.moment().subtract(18,"months").format("YYYY-MM-DD")]
				],
				fields: [
					"user_id","is_vacation","start_time","end_time","approved_by","rejected_by","notes"
				],
				include: [{
					model: "User",
					fields: ["first_name","last_name"]
				}]
			}

			this.getJSON("ScheduleEvent/get",params).then(response => {
				if (response.success) {
					vm.vacationRequests = response.data
					vm.numVacationRequests = response.data.length
				}
			})
		},
		fetchArchivableProjects() {
			let vm = this

			let params = {
				filters: [
					["date_completed <",this.moment().subtract(60,"days").format("YYYY-MM-DD")],
					["archived",0]
				],
				fields: ["id","slug","job_num","job_name","date_completed"]
			}

			this.getJSON("Job/get",params).then(response => {
				if (response.success) {
					vm.archivableProjects = response.data
					vm.numProjectsArchivable = response.data.length
				}
			})
		},
		fetchOutstandingChangeOrders() {
			let vm = this

			let params = {
				filters: [
					["quote_status",["Complete, Pending Approval"]],
					["Job.archived",0]
				],
				include: [{model: "Job", fields: ["id","slug","job_name","job_num","archived"]}]
			}

			this.outstandingChangeOrdersModal.spinner = true

			this.getJSON("JobChangeOrder/get",params).then(response => {
				if (response.success) {
					vm.outstandingChangeOrders = response.data
				}
				vm.outstandingChangeOrdersModal.spinner = false
			})
		}
	},
	created() {
		/*
		this.fetchReviewableLogs()
		this.fetchLocateTickets()
		this.fetchArchiveableServices()
		this.fetchArchivableProjects()
		this.fetchIncompleteServices()
		this.fetchVacationRequests()

		this.fetchUnopenedInvoices(true)
		this.fetchCompanyForms()
		this.fetchOutstandingChangeOrders()

		*/

	}
}
</script>

<style scoped>

.items-grid {
	padding: 10px;
	margin: 0;
}

.items-grid>div {
	width: 50%;
}

.review-item-panel {
	border: 1px solid #e0e0e0;
	padding: 15px;
	padding-top: 10px;
	padding-bottom: 10px;
	color: #50649c;
	display: block;
	width: 100%;
	height: 100%;
}

.review-item-panel:hover {
	text-decoration: none;
	background-color: #e2e5ec;
}

.review-item-panel .total {
	font-size: 26pt;
	font-weight: bold;
}

.review-item-panel h3 {
	font-size: 14pt;
	color: #50649c;
	margin-bottom: 0;
}

@media (max-width: 600px) {
	.items-grid>div {
		width: 100%;
	}
}

</style>